//TODO rewrite to vanilla :')

jQuery(document).ready(function ($) {
  var $body = $("body");
  var rangeValuesSeparator = "~";

  var _delay = parseInt(wcapf_params.filter_input_delay);

  var delay = _delay >= 0 ? _delay : 800; // Store fields' id and filter information.

  var fields = {};
  var $wcapfSingleFilters = $(".wcapf-single-filter");
  var $wcapfNavFilters = $(".wcapf-nav-filter");
  var $wcapfNumberRangeFilters = $(".wcapf-number-range-filter");
  var $wcapfDateFilters = $(".wcapf-date-range-filter");
  $wcapfSingleFilters.each(function () {
    var $field = $(this);
    var id = $field.attr("data-id");
    var $wrapper = $field.find(".wcapf-field-inner > div");
    var filterKey = $wrapper.attr("data-filter-key");
    var multipleFilter = parseInt($wrapper.attr("data-multiple-filter"));
    fields[id] = {
      filterKey: filterKey,
      multipleFilter: multipleFilter,
    };
  }); // Initialize jQuery chosen library.

  function initChosen() {
    if (!jQuery().chosen) {
      return;
    }

    $wcapfNavFilters.find(".wcapf-chosen-select").each(function () {
      var $this = $(this);
      var options = {};
      var noResultsMessage = $this.attr("data-no-results-message");

      if (noResultsMessage) {
        options["no_results_text"] = noResultsMessage;
      }

      var searchThreshold = parseInt(wcapf_params.chosen_lib_search_threshold);

      if (searchThreshold) {
        options["disable_search_threshold"] = searchThreshold;
      }

      $this.chosen(options);
    });
  }

  initChosen(); // Initialize hierarchy accordion.

  function initHierarchyAccordion() {
    $wcapfNavFilters.find(".hierarchy-accordion-toggle").on("click", function () {
      var $this = $(this);
      var $child = $this.parent("li").children("ul");
      $this.toggleClass("active");

      if (wcapf_params.enable_animation_for_hierarchy_accordion) {
        $child.slideToggle(wcapf_params.hierarchy_accordion_animation_speed, wcapf_params.hierarchy_accordion_animation_easing);
      } else {
        $child.toggle();
      }
    });
  }

  initHierarchyAccordion();
  /**
   * @source https://stackoverflow.com/a/34141813
   *
   * @param number
   * @param decimals
   * @param dec_point
   * @param thousands_sep
   *
   * @returns {string}
   */

  function number_format(number, decimals, dec_point, thousands_sep) {
    // Strip all characters but numerical ones.
    number = (number + "").replace(/[^\d+\-Ee.]/g, "");
    var n = !isFinite(+number) ? 0 : +number;
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
    var sep = typeof thousands_sep === "undefined" ? "," : thousands_sep;
    var dec = typeof dec_point === "undefined" ? "." : dec_point;
    var s;

    var toFixedFix = function toFixedFix(n, prec) {
      var k = Math.pow(10, prec);
      return "" + Math.round(n * k) / k;
    }; // Fix for IE parseFloat(0.55).toFixed(0) = 0;

    s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");

    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }

    if ((s[1] || "").length < prec) {
      s[1] = s[1] || "";
      s[1] += new Array(prec - s[1].length + 1).join("0");
    }

    return s.join(dec);
  } // Initialize noUISlider.

  function initNoUISlider() {
    if ("undefined" === typeof noUiSlider) {
      return;
    }

    $wcapfNumberRangeFilters.find(".wcapf-range-slider").each(function () {
      var $item = $(this);
      var filterKey = $item.attr("data-filter-key");
      var $slider = $item.find(".wcapf-noui-slider"); // If slider is already initialized then don't reinitialize again.

      if ($slider.hasClass("wcapf-noui-target")) {
        return;
      }

      var sliderId = $slider.attr("id");
      var displayValuesAs = $item.attr("data-display-values-as");
      var rangeMinValue = parseFloat($item.attr("data-range-min-value"));
      var rangeMaxValue = parseFloat($item.attr("data-range-max-value"));
      var step = parseFloat($item.attr("data-step"));
      var decimalPlaces = $item.attr("data-decimal-places");
      var thousandSeparator = $item.attr("data-thousand-separator");
      var decimalSeparator = $item.attr("data-decimal-separator");
      var minValue = parseFloat($item.attr("data-min-value"));
      var maxValue = parseFloat($item.attr("data-max-value"));
      var $minValue = $item.find(".min-value");
      var $maxValue = $item.find(".max-value");
      var slider = document.getElementById(sliderId);
      noUiSlider.create(slider, {
        start: [minValue, maxValue],
        step: step,
        connect: true,
        cssPrefix: "wcapf-noui-",
        range: {
          min: rangeMinValue,
          max: rangeMaxValue,
        },
      });
      slider.noUiSlider.on("update", function (values) {
        var minValue = number_format(values[0], decimalPlaces, decimalSeparator, thousandSeparator);
        var maxValue = number_format(values[1], decimalPlaces, decimalSeparator, thousandSeparator);

        if ("plain_text" === displayValuesAs) {
          $minValue.html(minValue);
          $maxValue.html(maxValue);
        } else {
          $minValue.val(minValue);
          $maxValue.val(maxValue);
        }

        $body.trigger("wcapf-nouislider-update", [$item, values]);
      });

      function filterProductsAccordingToSlider(values) {
        $body.trigger("wcapf-nouislider-before-filter-products", [$item, values]);
        var minValue = parseFloat(values[0]);
        var maxValue = parseFloat(values[1]);

        if (minValue === rangeMinValue && maxValue === rangeMaxValue) {
          var query = removeQueryStringParameter(filterKey);
          history.pushState({}, "", query);
        } else {
          var filterValString = minValue + rangeValuesSeparator + maxValue;
          updateQueryStringParameter(filterKey, filterValString);
        }

        filterProducts();
        $body.trigger("wcapf-nouislider-after-filter-products", [$item, values]);
      }

      slider.noUiSlider.on("change", function (values) {
        // Clear any previously set timer before setting a fresh one
        clearTimeout($item.data("timer"));
        $item.data(
          "timer",
          setTimeout(function () {
            $item.removeData("timer");
            filterProductsAccordingToSlider(values);
          }, delay)
        );
      });
      $minValue.on("input", function (event) {
        event.preventDefault();
        var $input = $(this); // Clear any previously set timer before setting a fresh one

        clearTimeout($input.data("timer"));
        $input.data(
          "timer",
          setTimeout(function () {
            $input.removeData("timer");
            var minValue = $input.val();
            slider.noUiSlider.set([minValue, null]);
            filterProductsAccordingToSlider(slider.noUiSlider.get());
          }, delay)
        );
      });
      $maxValue.on("input", function (event) {
        event.preventDefault();
        var $input = $(this); // Clear any previously set timer before setting a fresh one

        clearTimeout($input.data("timer"));
        $input.data(
          "timer",
          setTimeout(function () {
            $input.removeData("timer");
            var maxValue = $input.val();
            slider.noUiSlider.set([null, maxValue]);
            filterProductsAccordingToSlider(slider.noUiSlider.get());
          }, delay)
        );
      });
    });
  }

  initNoUISlider();

  function filterByDate($input) {
    var $wcapfDateFilter = $input.closest(".wcapf-date-input");
    var filterKey = $wcapfDateFilter.attr("data-filter-key");
    var isRange = $wcapfDateFilter.attr("data-is-range");
    var filterValue = "";
    var runFilter = false; // Clear any previously set timer before setting a fresh one

    clearTimeout($wcapfDateFilter.data("timer"));

    if (isRange) {
      var from = $wcapfDateFilter.find(".date-from-input").val();
      var to = $wcapfDateFilter.find(".date-to-input").val();

      if (from && to) {
        filterValue = from + rangeValuesSeparator + to;
        runFilter = true;
      } else if (!from && !to) {
        runFilter = true;
      }
    } else {
      var _from = $wcapfDateFilter.find(".date-from-input").val();

      if (_from) {
        filterValue = _from;
        runFilter = true;
      } else {
        runFilter = true;
      }
    }

    if (runFilter) {
      $wcapfDateFilter.data(
        "timer",
        setTimeout(function () {
          $wcapfDateFilter.removeData("timer");

          if (filterValue) {
            updateQueryStringParameter(filterKey, filterValue);
          } else {
            var query = removeQueryStringParameter(filterKey);
            history.pushState({}, "", query);
          }

          filterProducts();
        }, delay)
      );
    }
  }

  function initDatepicker() {
    if (!jQuery().datepicker) {
      return;
    }

    var $wcapfDateFilter = $wcapfDateFilters.find(".wcapf-date-input");
    var format = $wcapfDateFilter.attr("data-date-format");
    var yearDropdown = $wcapfDateFilter.attr("data-date-picker-year-dropdown");
    var monthDropdown = $wcapfDateFilter.attr("data-date-picker-month-dropdown");
    var $from = $wcapfDateFilter.find(".date-from-input");
    var $to = $wcapfDateFilter.find(".date-to-input");
    $from.datepicker({
      dateFormat: format,
      changeYear: yearDropdown,
      changeMonth: monthDropdown,
    });
    $to.datepicker({
      dateFormat: format,
      changeYear: yearDropdown,
      changeMonth: monthDropdown,
    });
    $from.on("change", function () {
      var $input = $(this);
      filterByDate($input);
    });
    $to.on("change", function () {
      var $input = $(this);
      filterByDate($input);
    });
  }

  initDatepicker();

  function initDefaultOrderBy() {
    // Attach chosen.
    if (wcapf_params.attach_chosen_on_sorting) {
      if (jQuery().chosen) {
        $body.find(".woocommerce-ordering select.orderby").chosen({
          disable_search_threshold: 15,
        });
      }
    }

    if (!wcapf_params.sorting_control) {
      $body.find(".woocommerce-ordering").each(function () {
        var $orderingForm = $(this);
        $orderingForm.on("change", "select.orderby", function () {
          $orderingForm.submit();
        });
      });
      return;
    }

    $body.find(".woocommerce-ordering").each(function () {
      var $orderingForm = $(this);
      $orderingForm.on("submit", function (e) {
        e.preventDefault();
      });
      $orderingForm.on("change", "select.orderby", function (e) {
        e.preventDefault();
        var order = $(this).val();
        var filter_key = "orderby";
        updateQueryStringParameter(filter_key, order);
        filterProducts();
      });
    });
  }

  initDefaultOrderBy();

  function updateProductsCountResult($results) {
    var selector = ".woocommerce-result-count";

    if ($(wcapf_params.shop_loop_container).find(selector).length) {
      return;
    }

    var newProductCount = $results.find(selector).html();
    $body.find(selector).html(newProductCount);
  }

  function showLoadingAnimation() {
    if (!wcapf_params.loading_animation) {
      return;
    }

    $.LoadingOverlay("show", wcapf_params.loading_overlay_options);
  }

  function disableNoUiSliders() {
    if ("undefined" === typeof noUiSlider) {
      return;
    }

    $wcapfNumberRangeFilters.find(".wcapf-noui-slider").each(function (e, element) {
      element.setAttribute("disabled", true);
    });
  }

  function disableLabels() {
    var selectors = ".wcapf-labeled-nav .item, .wcapf-active-filters .item";
    $wcapfSingleFilters.find(selectors).addClass("disabled");
  }

  function disableInputs() {
    if (!wcapf_params.disable_inputs_while_fetching_results) {
      return;
    }

    var inputs = "input, select";
    $wcapfSingleFilters.find(inputs).attr("disabled", "disabled");
    $wcapfSingleFilters.find(inputs).trigger("chosen:updated");
    disableNoUiSliders();
    disableLabels();
  }

  function enableNoUiSliders() {
    if ("undefined" === typeof noUiSlider) {
      return;
    }

    $wcapfNumberRangeFilters.find(".wcapf-noui-slider").each(function (e, element) {
      element.removeAttribute("disabled");
    });
  }

  function enableInputs() {
    if (!wcapf_params.disable_inputs_while_fetching_results) {
      return;
    }

    var inputs = "input";
    $wcapfNumberRangeFilters.find(inputs).removeAttr("disabled");
    $wcapfDateFilters.find(inputs).removeAttr("disabled");
    enableNoUiSliders();
  }

  function resetLoadingAnimation() {
    if (!wcapf_params.loading_animation) {
      return;
    }

    $.LoadingOverlay("hide");
  }

  function scrollTo() {
    if ("none" === wcapf_params.scroll_window) {
      return;
    }

    var scrollFor = wcapf_params.scroll_window_for;
    var isMobile = wcapf_params.is_mobile;
    var proceed = false;

    if ("mobile" === scrollFor && isMobile) {
      proceed = true;
    } else if ("desktop" === scrollFor && !isMobile) {
      proceed = true;
    } else if ("both" === scrollFor) {
      proceed = true;
    }

    if (!proceed) {
      return;
    }

    var adjustingOffset, offset;

    if (wcapf_params.scroll_to_top_offset) {
      adjustingOffset = parseInt(wcapf_params.scroll_to_top_offset);
    }

    var container;

    if ($(wcapf_params.shop_loop_container).length) {
      container = wcapf_params.shop_loop_container;
    } else if ($(wcapf_params.not_found_container).length) {
      container = wcapf_params.not_found_container;
    }

    if ("custom" === wcapf_params.scroll_window) {
      container = wcapf_params.scroll_window_custom_element;
    }

    var $container = $(container);

    if ($container.length) {
      offset = $container.offset().top - adjustingOffset;

      if (offset < 0) {
        offset = 0;
      }

      $("html, body").stop().animate(
        {
          scrollTop: offset,
        },
        wcapf_params.scroll_to_top_speed,
        wcapf_params.scroll_to_top_easing
      );
    }
  } // Things are done before fetching the products like showing a loading indicator.

  function beforeFetchingProducts() {
    disableInputs();
    showLoadingAnimation();

    if ("immediately" === wcapf_params.scroll_window_when) {
      scrollTo();
    }

    $body.trigger("wcapf_before_fetching_products");
  }

  function beforeUpdatingProducts($results) {
    resetLoadingAnimation();
    $body.trigger("wcapf_before_updating_products", [$results]);
  } // Things are done after applying the filter like scroll to top.

  function afterUpdatingProducts($results) {
    initChosen();
    initHierarchyAccordion();
    initNoUISlider();
    initDatepicker();
    initDefaultOrderBy();
    updateProductsCountResult($results);
    enableInputs();

    if ("after" === wcapf_params.scroll_window_when) {
      scrollTo();
    }

    $body.trigger("wcapf_after_updating_products", [$results]);
  } // The main filter function.

  function filterProducts() {
    var forceReRender = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    beforeFetchingProducts();
    $.get(window.location.href, function (data) {
      var $data = $(data); // Replace the fields' data with new data.

      $.each(fields, function (id) {
        var fieldID = '[data-id="' + id + '"]';
        var $field = $(fieldID);
        var $inner = $field.find(".wcapf-field-inner");

        var _field = $data.find(fieldID);

        var fieldClasses = $(_field).attr("class"); // Preserve hierarchy accordion state.

        if (wcapf_params.preserve_hierarchy_accordion_state) {
          if ($field.hasClass("hierarchy-accordion")) {
            $field.find(".hierarchy-accordion-toggle.active").each(function () {
              var itemValue = $(this).parent().children("input").val();
              var toggleSelector = 'input[value="' + itemValue + '"] ~ .hierarchy-accordion-toggle';
              var ulSelector = 'input[value="' + itemValue + '"] ~ ul';
              var _classes = "hierarchy-accordion-toggle active";

              _field.find(toggleSelector).attr("class", _classes);

              _field.find(ulSelector).show();
            });
          }
        }

        var _html = _field.find(".wcapf-field-inner").html(); // Show soft limit items.

        var softLimitSelector = "show-hidden-items";

        if ($field.hasClass(softLimitSelector)) {
          if (!_field.hasClass(softLimitSelector)) {
            fieldClasses += " " + softLimitSelector;
          }
        } else {
          fieldClasses = fieldClasses.replace(softLimitSelector, "");
        } // Update the field's class.

        $field.attr("class", fieldClasses.trim()); // When called from history back or forward request then rerender all fields.

        if (forceReRender) {
          // update field
          $inner.html(_html);
        } else {
          // Selectively rerender the fields.
          if ($field.hasClass("wcapf-nav-filter")) {
            // update field
            $inner.html(_html);
          }
        }

        $field.trigger("wcapf-field-updated", [_field]);
      });
      beforeUpdatingProducts($data); // Replace old shop loop with new one.

      var $shopLoopContainer = $data.find(wcapf_params.shop_loop_container);
      var $notFoundContainer = $data.find(wcapf_params.not_found_container);

      if (wcapf_params.shop_loop_container === wcapf_params.not_found_container) {
        $(wcapf_params.shop_loop_container).html($shopLoopContainer.html());
      } else {
        if ($(wcapf_params.not_found_container).length) {
          if ($shopLoopContainer.length) {
            $(wcapf_params.not_found_container).html($shopLoopContainer.html());
          } else if ($notFoundContainer.length) {
            $(wcapf_params.not_found_container).html($notFoundContainer.html());
          }
        } else if ($(wcapf_params.shop_loop_container).length) {
          if ($shopLoopContainer.length) {
            $(wcapf_params.shop_loop_container).html($shopLoopContainer.html());
          } else if ($notFoundContainer.length) {
            $(wcapf_params.shop_loop_container).html($notFoundContainer.html());
          }
        }
      }

      afterUpdatingProducts($data);
    });
  } // URL Parser

  function getUrlVars(url) {
    var vars = {},
      hash;

    if (typeof url === "undefined") {
      url = window.location.href;
    }

    url = url.replaceAll("%2C", ",");
    var hashes = url.slice(url.indexOf("?") + 1).split("&");
    var hLength = hashes.length;

    for (var i = 0; i < hLength; i++) {
      hash = hashes[i].split("=");
      vars[hash[0]] = hash[1];
    }

    return vars;
  } // everytime we apply the filter we set the current page to 1

  function fixPagination() {
    var url = window.location.href;
    var params = getUrlVars(url);
    var currentPageInUrl = parseInt(url.replace(/.+\/page\/(\d+)+/, "$1"));

    if (currentPageInUrl) {
      if (currentPageInUrl > 1) {
        url = url.replace(/page\/(\d+)/, "page/1");
      }
    } else if (typeof params["paged"] !== "undefined") {
      var currentPageInParams = parseInt(params["paged"]);

      if (currentPageInParams > 1) {
        url = url.replace("paged=" + currentPageInParams, "paged=1");
      }
    }

    return url;
  } // update query string for categories, meta etc..

  function updateQueryStringParameter(key, value, pushHistory, url) {
    if (typeof pushHistory === "undefined") {
      pushHistory = true;
    }

    if (typeof url === "undefined") {
      url = fixPagination();
    }

    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = url.indexOf("?") !== -1 ? "&" : "?";
    var urlWithQuery;

    if (url.match(re)) {
      urlWithQuery = url.replace(re, "$1" + key + "=" + value + "$2");
    } else {
      urlWithQuery = url + separator + key + "=" + value;
    }

    if (pushHistory === true) {
      return history.pushState({}, "", urlWithQuery);
    } else {
      return urlWithQuery;
    }
  } // remove parameter from url

  function removeQueryStringParameter(filterKey, url) {
    if (typeof url === "undefined") {
      url = fixPagination();
    }

    var oldParams = getUrlVars(url);
    var oldParamsLength = Object.keys(oldParams).length;
    var startPosition = url.indexOf("?");
    var filterKeyPosition = url.indexOf(filterKey);
    var cleanUrl, cleanQuery;

    if (oldParamsLength > 1) {
      if (filterKeyPosition - startPosition > 1) {
        cleanUrl = url.replace("&" + filterKey + "=" + oldParams[filterKey], "");
      } else {
        cleanUrl = url.replace(filterKey + "=" + oldParams[filterKey] + "&", "");
      }

      var newParams = cleanUrl.split("?");
      cleanQuery = "?" + newParams[1];
    } else {
      cleanQuery = url.replace("?" + filterKey + "=" + oldParams[filterKey], "");
    }

    return cleanQuery;
  } // take the key and value and make query

  function makeParameters(filterKey, filterValue) {
    var forceRerender = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var url = arguments.length > 3 ? arguments[3] : undefined;
    var valueSeparator = ",";
    var params,
      nextValues,
      emptyValue = false;

    if (typeof url !== "undefined") {
      params = getUrlVars(url);
    } else {
      params = getUrlVars();
    }

    if (typeof params[filterKey] != "undefined") {
      var prevValues = params[filterKey];
      var prevValuesArray = prevValues.split(valueSeparator);

      if (prevValues.length > 0) {
        var found = $.inArray(filterValue, prevValuesArray);

        if (found >= 0) {
          // Element was found, remove it.
          prevValuesArray.splice(found, 1);

          if (prevValuesArray.length === 0) {
            emptyValue = true;
          }
        } else {
          // Element was not found, add it.
          prevValuesArray.push(filterValue);
        }

        if (prevValuesArray.length > 1) {
          nextValues = prevValuesArray.join(valueSeparator);
        } else {
          nextValues = prevValuesArray;
        }
      } else {
        nextValues = filterValue;
      }
    } else {
      nextValues = filterValue;
    } // update url and query string

    if (!emptyValue) {
      updateQueryStringParameter(filterKey, nextValues);
    } else {
      var query = removeQueryStringParameter(filterKey);
      history.pushState({}, "", query);
    }

    filterProducts(forceRerender);
  }

  function singleFilter(filterKey, filterValue) {
    var params = getUrlVars();
    var query;

    if (typeof params[filterKey] !== "undefined" && params[filterKey] === filterValue) {
      query = removeQueryStringParameter(filterKey);
    } else {
      query = updateQueryStringParameter(filterKey, filterValue, false);
    } // update url

    history.pushState({}, "", query);
    filterProducts();
  } // Handle the pagination request via ajax.

  if (wcapf_params.enable_pagination_via_ajax && wcapf_params.pagination_container) {
    var $container = $(wcapf_params.shop_loop_wrapper);
    var selector = wcapf_params.pagination_container + " a";

    if ($container.length) {

      document.querySelector(wcapf_params.shop_loop_wrapper).addEventListener("click", function (e) {
        if (e.target.matches(selector)) {
          e.preventDefault();
          var location = e.target.getAttribute("href");
          history.pushState({}, "", location);
          filterProducts();
        }
      }, false);
    }
  }

  function handleFilterRequest($item, filterValue) {
    var $field = $item.closest(".wcapf-single-filter");
    var fieldID = $field.attr("data-id");
    var fieldData = fields[fieldID];
    var filterKey = fieldData.filterKey;
    var multipleFilter = fieldData.multipleFilter;

    if (!filterKey) {
      return;
    }

    if (!filterValue.length) {
      var query = removeQueryStringParameter(filterKey);
      history.pushState({}, "", query);
      filterProducts();
      return;
    }

    if (multipleFilter) {
      makeParameters(filterKey, filterValue);
    } else {
      singleFilter(filterKey, filterValue);
    }
  } // Handle the filter request for list field.

  $wcapfNavFilters.on("change", '.wcapf-layered-nav [type="checkbox"], .wcapf-layered-nav [type="radio"]', function (event) {
    event.preventDefault();
    var $item = $(this);
    var filterValue = $item.val();
    handleFilterRequest($item, filterValue);
  }); // Handle the filter request for labeled item.

  $wcapfNavFilters.on("click", ".wcapf-labeled-nav .item:not(.disabled)", function (event) {
    event.preventDefault();
    var $item = $(this);
    var filterValue = $item.attr("data-value");
    handleFilterRequest($item, filterValue);
  }); // Handle the filter request for display type select fields.

  $wcapfNavFilters.on("change", "select", function (event) {
    event.preventDefault();
    var $item = $(this);
    var filterValue = $item.val();
    var $field = $item.closest(".wcapf-single-filter");
    var fieldID = $field.attr("data-id");
    var fieldData = fields[fieldID];
    var filterKey = fieldData.filterKey;

    if (!filterValue.length) {
      var query = removeQueryStringParameter(filterKey);
      history.pushState({}, "", query);
    } else {
      var filterValString = filterValue.toString();
      updateQueryStringParameter(filterKey, filterValString);
    }

    filterProducts();
  });
  /**
   * Handle the filter request for range number.
   */

  var rangeNumberSelectors = ".wcapf-range-number .min-value, .wcapf-range-number .max-value";
  $wcapfNumberRangeFilters.on("input", rangeNumberSelectors, function (event) {
    event.preventDefault();
    var $item = $(this); // Clear any previously set timer before setting a fresh one

    clearTimeout($item.data("timer"));
    $item.data(
      "timer",
      setTimeout(function () {
        $item.removeData("timer");
        var $rangeNumber = $item.closest(".wcapf-range-number");
        var filterKey = $rangeNumber.attr("data-filter-key");
        var rangeMinValue = $rangeNumber.attr("data-range-min-value");
        var rangeMaxValue = $rangeNumber.attr("data-range-max-value");
        var minValue = $rangeNumber.find(".min-value").val();
        var maxValue = $rangeNumber.find(".max-value").val(); // Force the minValue not to be empty.

        if (!minValue.length) {
          minValue = rangeMinValue;
          $rangeNumber.find(".min-value").val(minValue);
        } // Force the maxValue not to be empty.

        if (!maxValue.length) {
          maxValue = rangeMaxValue;
          $rangeNumber.find(".max-value").val(maxValue);
        } // Force the minValue not to go below the rangeMinValue.

        if (parseFloat(minValue) < parseFloat(rangeMinValue)) {
          minValue = rangeMinValue;
          $rangeNumber.find(".min-value").val(minValue);
        } // Force the minValue not to go up the rangeMaxValue.

        if (parseFloat(minValue) > parseFloat(rangeMaxValue)) {
          minValue = rangeMaxValue;
          $rangeNumber.find(".min-value").val(minValue);
        } // Force the maxValue not to go up the rangeMaxValue.

        if (parseFloat(maxValue) > parseFloat(rangeMaxValue)) {
          maxValue = rangeMaxValue;
          $rangeNumber.find(".max-value").val(maxValue);
        } // Force the maxValue not to go below the minValue.

        if (parseFloat(minValue) > parseFloat(maxValue)) {
          maxValue = minValue;
          $rangeNumber.find(".max-value").val(maxValue);
        }

        if (minValue === rangeMinValue && maxValue === rangeMaxValue) {
          var query = removeQueryStringParameter(filterKey);
          history.pushState({}, "", query);
        } else {
          var filterValString = minValue + rangeValuesSeparator + maxValue;
          updateQueryStringParameter(filterKey, filterValString);
        }

        filterProducts();
      }, delay)
    );
  }); // Handle removing the active filters.

  $wcapfNavFilters.on("click", ".wcapf-active-filters .item:not(.disabled)", function (event) {
    event.preventDefault();
    var $item = $(this);
    var filterKey = $item.attr("data-filter-key");
    var filterValue = $item.attr("data-value");
    makeParameters(filterKey, filterValue, true);
  });

  function resetFilters($button) {
    var _filterKeys = $button.attr("data-keys");

    if (!_filterKeys) {
      return;
    }

    var filterKeys = _filterKeys.split(",");

    var query = "";
    $.each(filterKeys, function (i, filterKey) {
      if (query) {
        query = removeQueryStringParameter(filterKey, query);
      } else {
        query = removeQueryStringParameter(filterKey);
      }
    }); // Empty query causes issue(doesn't remove the filter keys from the url),
    // this is why we are setting the page url as query.

    if (!query) {
      var prevUrl = window.location.href;
      var newUrl = prevUrl.split("?");
      query = newUrl[0];
    }

    history.pushState({}, "", query);
    filterProducts(true);
  } // Clear/Reset all filters.

  $body.on("wcapf-reset-filters", function (e, $button) {
    resetFilters($button);
  });
  $wcapfNavFilters.on("click", ".wcapf-reset-filters-btn", function (event) {
    event.preventDefault();
    var $button = $(this);
    $body.trigger("wcapf-reset-filters", [$button]);
  });
  $wcapfSingleFilters.on("wcapf-clear-filter", function () {
    var $field = $(this);
    var fieldID = $field.attr("data-id");
    var fieldData = fields[fieldID];
    var filterKey = fieldData.filterKey;
    var query = removeQueryStringParameter(filterKey);
    history.pushState({}, "", query);
    filterProducts(true);
  });
  $body.on("wcapf-run-filter-products", function (e, forceReRender) {
    filterProducts(forceReRender);
  });

  if ($(wcapf_params.shop_loop_container).length || $(wcapf_params.not_found_container).length) {
    if (wcapf_params.apply_filters_on_browser_history_change) {
      $(window).bind("popstate", function () {
        filterProducts(true);
      });
    }
  }
  /**
   * Make it compatible with other plugins.
   */

  $body.on("wcapf_after_updating_products", function () {
    // woo-variation-swatches
    $(document).trigger("woo_variation_swatches_pro_init");
  });
});
